"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var HeroModuleForm_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeroModuleForm = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const validate_js_1 = require("validate.js");
const backoffice_1 = require("../../dsl/backoffice");
const services_1 = require("../../services");
const form_1 = require("../_abstract/form");
const _contracts_1 = require("../_contracts");
const form_2 = require("../_components/form");
/**
 * Component that contains a complete questionnaire needed to **EDIT** the `Hero`'s contents.
 *
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 */
let HeroModuleForm = HeroModuleForm_1 = class HeroModuleForm extends form_1.AbstractModuleForm {
    constructor() {
        super(...arguments);
        this.icons = backoffice_1.DashmixIconName;
        /**
         * Image title to display (from related services)
         */
        this.imgTitle = '';
        /**
         * Selected image thumbnail.
         */
        this.thumbnail = null;
        /**
         * @inheritDoc
         * @override
         */
        this.initialContent = HeroModuleForm_1.getInitialContent();
    }
    /**
     * Paragraph parsed from tag <br>
     */
    get textLarge() {
        if (!this._content.textLarge) {
            return '';
        }
        return this._content.textLarge.replace(/<br\s*[/]?>/gi, '\n');
    }
    /**
     * Paragraph parsed with tag <br>
     */
    set textLarge(value) {
        this._content.textLarge = value.replace(/(?:\r\n|\r|\n)/g, '<br />');
    }
    /**
     * Paragraph parsed from tag <br>
     */
    get textSmall() {
        if (!this._content.textSmall) {
            return '';
        }
        return this._content.textSmall.replace(/<br\s*[/]?>/gi, '\n');
    }
    /**
     * Paragraph parsed with tag <br>
     */
    set textSmall(value) {
        this._content.textSmall = value.replace(/(?:\r\n|\r|\n)/g, '<br />');
    }
    /**
     * Get video URL
     *
     * @return string
     */
    get video() {
        if (!this._content.backgroundObj || !this._content.backgroundObj.video) {
            return '';
        }
        else if (!this._content.backgroundObj.video.desktop) {
            return '';
        }
        return this._content.backgroundObj.video.desktop;
    }
    /**
     * Set video URL
     *
     * @return string
     */
    set video(value) {
        if (!this._content.backgroundObj) {
            this._content.backgroundObj = {
                video: {
                    desktop: value,
                    mobile: null
                },
                image: {}
            };
            return;
        }
        if (!this._content.backgroundObj.video) {
            this._content.backgroundObj.video = {
                desktop: value,
                mobile: null
            };
            return;
        }
        this._content.backgroundObj.video.desktop = value;
    }
    /**
     * Get video form mobile devices URL
     *
     * @return string
     */
    get videoMobile() {
        if (!this._content.backgroundObj || !this._content.backgroundObj.video) {
            return '';
        }
        else if (!this._content.backgroundObj.video.mobile) {
            return '';
        }
        return this._content.backgroundObj.video.mobile;
    }
    /**
     * Set video form mobile devices URL
     *
     * @return string
     */
    set videoMobile(value) {
        if (!this._content.backgroundObj) {
            this._content.backgroundObj = {
                video: {
                    desktop: null,
                    mobile: value
                },
                image: {}
            };
            return;
        }
        if (!this._content.backgroundObj.video) {
            this._content.backgroundObj.video = {
                desktop: null,
                mobile: value
            };
            return;
        }
        this._content.backgroundObj.video.mobile = value;
    }
    /**
     * Vue lifecycle hook.
     */
    mounted() {
        this.$nextTick(() => {
            this.findImageRelated();
        });
    }
    /**
     * Add button to HERO
     */
    addButton() {
        this._content.button = {
            target: '',
            label: ''
        };
    }
    /**
     * Delete button from HERO
     */
    deleteButton() {
        this._content.button = null;
    }
    /**
     * Function to check if background image is selected.
     */
    hasImage() {
        return !!this._content.backgroundObj && !!this._content.backgroundObj.image && typeof this._content.backgroundObj.image.value !== 'undefined';
    }
    /**
     * Function to find background image source
     */
    findImageSource() {
        this.pickRelated(services_1.Picker.Media, this.setImageSource);
    }
    /**
     * Function to remove background image
     */
    removeBackground() {
        this._content.backgroundObj = null;
        this.thumbnail = null;
        this.imgTitle = '';
    }
    /**
     * Method to find image related
     */
    findImageRelated() {
        if (!this._content.backgroundObj || !this._content.backgroundObj.image || !this._content.backgroundObj.image.value) {
            return;
        }
        const related = this.relatedService.resolve(this._content.backgroundObj.image, {});
        if (!validate_js_1.isPromise(related)) {
            return;
        }
        related.then((related) => {
            if (Object.prototype.hasOwnProperty.call(related, 'caption') && Object.prototype.hasOwnProperty.call(related, 'url')) {
                this.imgTitle = related.caption;
                this.thumbnail = {
                    type: '',
                    thumbnail: related.url
                };
            }
            if (Object.prototype.hasOwnProperty.call(related, 'title')) {
                this.imgTitle = related.title;
            }
            // FIXME: Some files miss property `file`.
            // if (Object.prototype.hasOwnProperty.call(related, 'file')) {
            this.thumbnail = {
                type: related.file ? related.file.type : 'jpg',
                thumbnail: related.url
            };
            // }
        }).catch(error => {
            console.debug(error);
        });
    }
    /**
     * Function to set background image source
     */
    setImageSource(source) {
        if (!this._content.backgroundObj) {
            this._content.backgroundObj = {
                image: source,
                video: null
            };
        }
        else {
            this._content.backgroundObj.image = source;
        }
        this.$nextTick(() => {
            this.findImageRelated();
        });
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialConfig() {
        return {
            driver: _contracts_1.ModuleDriver.Hero,
            size: {
                colSpan: 6,
                isResizable: false,
                maxColSpan: 6,
                maxRowSpan: 1,
                minColSpan: 1,
                minRowSpan: 1,
                rowSpan: 1
            }
        };
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialContent() {
        return {
            backgroundObj: null,
            button: null,
            textSmall: '',
            textLarge: ''
        };
    }
};
HeroModuleForm = HeroModuleForm_1 = __decorate([
    vue_property_decorator_1.Component({
        name: 'HeroModuleForm',
        components: {
            DashmixButton: backoffice_1.DashmixButton,
            DashmixFile: backoffice_1.DashmixFile,
            DashmixInput: backoffice_1.DashmixInput,
            DashmixTextArea: backoffice_1.DashmixTextArea,
            FormErrors: form_2.FormErrors
        },
        template: `
    <div>
    <div class="row m-0">
      <!-- Hero text -->
      <div class="col-12 col-md-8 pl-md-0">
        <div class="mb-4">
          <label class="d-block">{{ $t('forms.hero.text.label') }}</label>

          <div class="form-group mb-4">
            <label for="large" class="d-block">{{ $t('forms.hero.textLarge.label') }}</label>
            <DashmixTextArea :model.sync="textLarge" name="large" :rows="4"
                             :placeholder="$t('forms.hero.textLarge.placeholder')" />
          </div>

          <div class="form-group mb-4">
            <label for="small" class="d-block">{{ $t('forms.hero.textSmall.label') }}</label>
            <DashmixTextArea :model.sync="textSmall" name="small" :rows="4"
                             :placeholder="$t('forms.hero.textSmall.placeholder')" />
          </div>
        </div>
        <!-- Hero text || END -->

        <!-- Hero button -->
        <div class="mb-4">
          <label class="d-block">{{ $t('forms.hero.button.label') }}</label>
          <DashmixButton v-if="!_content.button"
                         variant="alt" class="btn-block"
                         :icon="icons.PlusSolid" :label="$t('forms.hero.button.button')"
                         @click="addButton" />

          <div v-else class="row m-0">
            <div class="col-11 px-0">
              <div class="row m-0">
                <div class="col-12 col-md-6 pl-md-0 form-group mb-4">
                  <label for="label" class="d-block">{{ $t('forms.hero.buttonLabel.label') }}</label>
                  <DashmixInput :model.sync="_content.button.label" name="label"
                                :placeholder="$t('forms.hero.buttonLabel.placeholder')" />
                </div>

                <div class="col-12 col-md-6 mb-4 pr-md-0 form-group mb-4">
                  <label for="small" class="d-block">
                    {{ $t('forms.hero.buttonTarget.label') }}
                    <abbr :title="$t('forms.hero.buttonTarget.abbr')">?</abbr>
                  </label>
                  <DashmixInput :model.sync="_content.button.target" name="small"
                                :placeholder="$t('forms.hero.buttonTarget.placeholder')" />
                </div>
              </div>
            </div>

            <div class="col-1 d-flex align-items-center p-0">
              <DashmixButton variant="icon" :icon="icons.TrashSolid" theme="danger"
                             @click="deleteButton" />
            </div>
          </div>
        </div>
      </div>
      <!-- Hero button || END -->

      <!-- Background -->
      <div class="col-12 col-md-4 pr-md-0">
        <div class="form-group mb-4">
          <label class="d-block">{{ $t('forms.hero.background') }}</label>
          <!-- Image -->
          <DashmixButton v-if="!disabled"
                         variant="alt" :class="{'mb-4': !hasImage() }" class="btn-block"
                         :icon="icons.SearchSolid" :label="$t('forms.shared.search')"
                         @click="findImageSource" />

          <figure v-if="thumbnail && hasImage()" class="figure-with-btn__image-container mt-4">
            <DashmixFile class="figure-with-btn__image" :file="thumbnail" />
            <DashmixButton v-if="!disabled"
                           class="figure-with-btn__delete-btn" variant="icon" size="small" theme="danger"
                           :icon="icons.TrashSolid" @click="removeBackground" />
            <figcaption>{{ imgTitle }}</figcaption>
          </figure>
          <!-- Image || END -->
        </div>

        <div class="form-group">
          <!-- Video links -->
          <label for="video" class="d-block">{{ $t('forms.hero.video.label') }}</label>
          <DashmixInput :model.sync="video" name="video"
                        :placeholder="$t('forms.hero.video.placeholder')" :disabled="!_content.backgroundObj" />
        </div>
        <div class="form-group">
          <label for="videoMobile" class="d-block">{{ $t('forms.hero.videoMobile.label') }}</label>
          <DashmixInput :model.sync="videoMobile" name="videoMobile"
                        :placeholder="$t('forms.hero.videoMobile.placeholder')" :disabled="!_content.backgroundObj" />
        </div>
        <!-- Video links || END -->
      </div>
    </div>
    <!-- Background  || END -->

    <!-- Form errors -->
    <FormErrors v-if="errors" v-bind="{ errors }" class="mt-3" />
    </div>`
    })
], HeroModuleForm);
exports.HeroModuleForm = HeroModuleForm;
//# sourceMappingURL=Hero.form.js.map